/**
 * Shared trade-in helpers for storefront scripts.
 * Keep the "Trade-In" property rule in sync with snippets/line-item-is-trade-in.liquid.
 */
(function (global) {
  function isTradeInPropertyKey(key) {
    return typeof key === 'string' && key.includes('Trade-In');
  }

  function lineHasTradeIn(item) {
    if (!item || !item.properties) return false;
    if (Array.isArray(item.properties)) {
      return item.properties.some(function (pair) {
        return isTradeInPropertyKey(pair && pair[0]);
      });
    }
    return Object.keys(item.properties).some(isTradeInPropertyKey);
  }

  function cartHasTradeIn(cart) {
    return ((cart && cart.items) || []).some(lineHasTradeIn);
  }

  global.CardoTradeIn = {
    isTradeInPropertyKey: isTradeInPropertyKey,
    lineHasTradeIn: lineHasTradeIn,
    cartHasTradeIn: cartHasTradeIn,
  };
})(typeof window !== 'undefined' ? window : globalThis);
